import { Link } from 'react-router-dom';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-extrabold">韩国理论片</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              专注收集与解读韩国剧情电影及理论电影，以杂志编辑的方式，为深度影迷提供影片介绍、影评解析与行业资讯。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-wider text-background-100">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { to: '/', label: '首页' },
                { to: '/category', label: '电影分类' },
                { to: '/special', label: '影评专题' },
                { to: '/news', label: '资讯' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-wider text-background-100">热门专题</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { to: '/special', label: '阶层寓言专题' },
                { to: '/special', label: '复仇美学专题' },
                { to: '/special', label: '现实主义专题' },
                { to: '/special', label: '类型拼贴专题' },
              ].map((l, i) => (
                <li key={i}>
                  <Link to={l.to} className="text-sm text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-wider text-background-100">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true" />
                <a href="mailto:hello@hanguolilunpian.com" className="hover:text-accent-300 transition-colors cursor-pointer">
                  hello@hanguolilunpian.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-wechat-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>微信公众号：韩国理论片</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>内容编辑部 · 首尔 / 上海</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {year} 韩国理论片 Korean Cinema Review. 保留所有权利。
          </p>
          <p className="text-xs text-background-200/70 text-center sm:text-right">
            本站内容均为虚构或公开资料示范，未接入真实电影数据库或第三方接口。
          </p>
        </div>
      </div>
    </footer>
  );
}